// context for fetch avvisi
import React, { createContext, useContext } from 'react'
import { useAvvisi } from '../hooks/interventi'
import { Intervento } from '../types'

interface AvvisiContextType {
  avvisi: Intervento[] | undefined
  isLoading: boolean
  refetch: () => void
}

const AvvisiContext = createContext<AvvisiContextType | undefined>(undefined)

export const AvvisiProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const { data: avvisi, isLoading, refetch } = useAvvisi()

  return (
    <AvvisiContext.Provider value={{ avvisi, isLoading, refetch }}>
      {children}
    </AvvisiContext.Provider>
  )
}

export const useAvvisiContext = (): AvvisiContextType => {
  const context = useContext(AvvisiContext)
  if (!context) {
    throw new Error('useAvvisiContext must be used within an AvvisiProvider')
  }
  return context
}
